import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserEntrieLog, UserEntrieLogTable } from 'app/shared/model';
import { Subscription } from 'rxjs';
import { DateService } from 'app/shared/services/date.service';
import { UsersService } from 'app/configuration/users/users.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'mh-entries-log',
    templateUrl: './entries-log.component.html',
    styleUrls: ['./entries-log.component.scss'],
    standalone: false
})
export class EntriesLogComponent implements OnInit, OnDestroy {
  dataSource: MatTableDataSource<UserEntrieLogTable>;
  displayedColumns: string[] = [
    'hotel',
    'chain',
    'name',
    'lastname',
    'email',
    'position',
    'role_id',
    'entries',
    'last_entrie',
  ];
  endDate: string;
  showChain = new FormControl(false);
  showChainSubs: Subscription;
  startDate: string;
  filter = '';
  waiting = false;
  columnsData = [
    { column: 'hotel', translation: 'commons.hotel' },
    { column: 'chain', translation: 'commons.chain' },
    { column: 'name', translation: 'models.user.name' },
    { column: 'lastname', translation: 'models.user.lastName' },
    { column: 'email', translation: 'models.user.email' },
    { column: 'position', translation: 'models.user.job_title' },
    { column: 'role_id', translation: 'configuration.users.entries_log.role' },
    { column: 'entries', translation: 'configuration.users.entries_log.entries' },
    { column: 'last_entrie', translation: 'configuration.users.entries_log.last_entry' },
  ];

  @ViewChild(MatPaginator) set paginator(p: MatPaginator) {
    if (p && this.dataSource) {
      p.pageIndex = 0;
      this.dataSource.paginator = p;
    }
  }
  @ViewChild(MatSort) set sort(s: MatSort) {
    if (s && this.dataSource) {
      this.dataSource.sort = s;
      this.dataSource.sortingDataAccessor = (data, column) =>
        column === 'role_id' ? this.roleLabel(data) : data[column];
    }
  }

  constructor(
    private usersService: UsersService,
    private dateService: DateService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.usersService.clearShowChainDataEntries();
    this.showChainSubs = this.showChain.valueChanges
      .subscribe((value: boolean) => {
        this.usersService.setShowChainDataEntries(value);
        if ( this.currentDates.startDate && this.currentDates.endDate ) {
          this.getUserEntries(value);
        }
      });
  }

  setDateFilter(event): void {
    if (event.currentDates) {
    }
  }

  roleLabel(row: UserEntrieLogTable): string {
    const key = `models.user_profile.roles.${row.role_id}`;
    const label = this.translate.instant(key);
    return label === key ? row.role || '-' : label;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement)?.value || '';
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  updateDataSource(data: UserEntrieLogTable[]): void {
    this.dataSource = new MatTableDataSource(data);
  }

  getUserEntries(showChain = false): void {
    if ( this.currentDates.startDate && this.currentDates.endDate) {

    this.waiting = true;
    this.filter = '';
    this.startDate = this.currentDates.startDate;
    this.endDate = this.currentDates.endDate;
    const customerIds = this.usersService.getCustomerIds(showChain);
    this.usersService.getUsersEntries(customerIds, this.startDate, this.endDate)
      .subscribe((data: UserEntrieLog[]) => {
        const dataToTable = this.mapDataToTable(data);
        this.updateDataSource(dataToTable);
        this.waiting = false;
      }, () => this.waiting = false);
    }
  }

  mapDataToTable(data: UserEntrieLog[]): UserEntrieLogTable[] {
    return data.map(({ hotel, chain, name, lastname, email, position, role, role_id, entries, last_entrie }) => ({
      hotel,
      chain,
      name,
      lastname,
      email,
      position,
      role,
      role_id,
      entries,
      last_entrie,
    }));
  }

  ngOnDestroy(): void {
    this.showChainSubs.unsubscribe();
    this.usersService.clearShowChainDataEntries();
  }

  handleDatepickerUpdated($event) {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates)
    const showChain = this.showChain.value;
    this.getUserEntries(showChain);
  }

  get currentDates() {
    return this.dateService.currentDates;
  }

  get currentFilterDate() {
    return this.dateService.currentFilter;
  }
}
